import { LoaderCircle } from 'lucide-react';

import { cn } from '@/lib/utils/cn';

interface SpinnerProps {
  className?: string;
  label?: string;
}

export function Spinner({ className, label = 'Cargando…' }: SpinnerProps) {
  return (
    <span role="status" className="inline-flex items-center">
      <LoaderCircle
        className={cn('size-4 animate-spin text-muted-foreground', className)}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
